import React, { Suspense, lazy } from 'react';

import FullScreenLoading from 'apps/home/landing/sections/fullScreenLoading';

const LandingPageLazy = lazy(() => import('apps/home/landing/landingPage'));

export default function LandingPage(props) {
  return (
    <Suspense fallback={<FullScreenLoading />}>
      <LandingPageLazy {...props} />
    </Suspense>
  );
}
